import { Cookies } from 'react-cookie';

export const isAuthorized = () =>
  !!new Cookies(window.document.cookie).get('access_token');
